import React from 'react';
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import * as moment from 'moment';
import 'moment/locale/es';
import MatchType from '../matchType/matchType';
import TeamsApi from "../../api/Teams";
import CourtsApi from "../../api/Courts";
import RefereesApi from "../../api/Referees";
import LeaguesApi from "../../api/Leagues";
import TournamentsApi from "../../api/Tournaments";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './form.css';

export default class MatchForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            match: this.props.selected ? {
                id: this.props.selected.id,
                team1_id: this.props.selected.team1_id || 0,
                goals1: this.props.selected.goals1 || 0,
                team2_id: this.props.selected.team2_id || 0,
                goals2: this.props.selected.goals2 || 0,
                court_id: this.props.selected.court_id || 0,
                referee_id: this.props.selected.referee_id || 0,
                league1_id: this.props.selected.league1_id || 0,
                league2_id: this.props.selected.league2_id || 0,
                tournament_id: this.props.selected.tournament_id || 0,
                day: moment(this.props.selected.day) || moment(),
                type: this.props.selected.type || 'Jornada',
                status: this.props.selected.status || 1
            } : {
                team1_id: 0,
                goals1: 0,
                team2_id: 0,
                goals2: 0,
                court_id: 0,
                referee_id: 0,
                league1_id: 0,
                league2_id: 0,
                tournament_id: 0,
                day: moment(),
                type: 'Jornada',
                status: 1
            },
            teams: this.props.teams,
            tournaments: [],
            leagues: [],
            referees: this.props.referees,
            courts: this.props.courts,
            selectedOption: this.props.selected ? this.props.selected.team1 || 0 : 0,
            selectedOption2: this.props.selected ? this.props.selected.team2 || 0: 0
        }
    }

    handleChange = (selectedOption) => {
        if(selectedOption != null){
            var st = {...this.state}
            st.selectedOption = selectedOption;
            st.match.team1_id = selectedOption.value;
            st.match.league1_id = selectedOption.league_id;
            var ar = this.getOptions(selectedOption,false);
            st.teams = ar;
            this.setState(st)
        }
    }

    handleChange2 = (selectedOption2) => {
        if(selectedOption2!=null){
            var st = {...this.state}
            st.selectedOption2 = selectedOption2;
            st.match.team2_id = selectedOption2.value;
            st.match.league2_id = selectedOption2.league_id;
            var ar = this.getOptions(selectedOption2,false);
            st.teams = ar;
            this.setState(st)
        }
    }

    componentWillMount(){
        let state = {...this.state};
            state.referees = this.props.referees;
            state.courts = this.props.courts;
            // state.teams = this.props.teams;
            state.teams = this.getOptions(this.props.teams.filter(t => t.status !=0),true);
            this.setState(state);
    }

    handleKeyPress(e){
        if (e.key === 'Enter') {
            this.props.save(this.state.match)
        }
    }

    onDateChange(d){
        let state = {...this.state};
        state.match.day = d
        this.setState(state);
    }

    onTypeChange(d){
        let state = {...this.state};
        state.match.type = d
        this.setState(state);
    }

    getOptions = (input,flag) => {
        if(flag==true)
            var obj = input
        else
            var obj = this.state.teams
        var arr = [];
        for (var key in obj) {
            if(obj[key]["value"]==input.value && flag==false && obj[key]["team"])
                arr.push({"label": obj[key]["team"]+" -- "+ obj[key]["league"],"value":obj[key]["id"], disabled: true});
            else
                if(obj[key]["value"]==input.value && flag==false && !obj[key]["team"])
                    arr.push({"label": obj[key]["label"],"value":obj[key]["value"],disabled: true});
                else
                    if(flag==false)
                        arr.push({"label": obj[key]["label"],"value":obj[key]["value"],"league_id":obj[key]["league_id"],"tournament":obj[key]["tournament"]});
                    else
                        arr.push({"label": obj[key]["team"]+" -- "+ obj[key]["league"]+' -- '+obj[key]["tournament"],"value":obj[key]["id"],"league_id":obj[key]["league_id"],"tournament": obj[key]["tournament"]});
        }
        return arr;
      }

    render(){
        console.log("this.state.teams")
        console.log(this.state.teams)
        return(
            <div>
                <div className="columns is-multiline">
                    <div className="column">
                        <label className="label">Fecha</label>
                            <Datepicker
                                timeIntervals={60}//60 canchitahmo --- 10 futcenter
                                selected={this.state.match.day}
                                onChange={(date) => this.onDateChange(date)}
                                showMonthDropdown
                                dateFormat="DD/MM/YYYY hh:mm a"
                                showTimeSelect={true}
                                className="input"
                                placeholderText="dd/mm/yyyy H:mm:ss"
                            />
                    </div>
                    <div className="column">
                        <label className="label">Tipo de juego</label>
                        <MatchType
                            onChange={(t) => this.onTypeChange(t)}
                        />
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Equipo 1</label>
                    </div>
                    <div className="field-body">
                        {this.state.teams &&
                            <Select className="input"
                                name="form-field-name"
                                value={(this.state.selectedOption[0]) ? this.state.selectedOption[0] : this.state.selectedOption}
                                onChange={this.handleChange}
                                options={this.state.teams}
                            />
                        }
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Equipo 2</label>
                    </div>
                    <div className="field-body">
                        {this.state.teams &&
                            <Select className="input"
                                name="form-field-name"
                                value={(this.state.selectedOption2[0]) ? this.state.selectedOption2[0] : this.state.selectedOption2}
                                onChange={this.handleChange2}
                                options={this.state.teams}
                            />
                        }
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Árbitro</label>
                    </div>
                    <div className="field-body">
                        <select
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            className="input"
                            onChange={(e) => {
                                let state = {...this.state};
                                let index = e.currentTarget.selectedIndex - 1;
                                state.match.referee_id = this.state.referees[index].id;
                                this.setState(state);
                            }}
                        >
                            <option disabled={false} selected={true} defaultValue={true}>Seleccionar...</option>
                            {this.state.referees.map(l => {
                                return (
                                    <option key={l.id} defaultValue={l.id === this.state.match.referee_id  ? "selected" :"" }>
                                        {l.name}
                                    </option>
                                )
                            })}

                        </select>
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Cancha</label>
                    </div>
                    <div className="field-body">
                        <select
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            className="input"
                            onChange={(e) => {
                                let state = {...this.state};
                                let index = e.currentTarget.selectedIndex - 1;
                                state.match.court_id = this.state.courts[index].id;
                                this.setState(state);
                            }}
                        >
                            <option disabled={false} defaultValue={true}>Seleccionar...</option>
                            {this.state.courts.map(l => {
                                return (
                                    <option key={l.id} defaultValue={l.id === this.state.match.court_id ? "selected" :"" }>
                                        {l.name}
                                    </option>
                                )
                            })}

                        </select>
                    </div>
                </div>
                <div className="columns has-text-right buttons-modal">
                    <div className="column">
                        <button
                            disabled={!this.state.match.day || !this.state.match.team1_id || !this.state.match.team2_id }
                            className="button is-success"
                            onClick={() => this.props.save(this.state.match)}>
                            Guardar
                        </button>
                        <button className="button" onClick={() => this.props.cancel()}>Cancelar</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/matches/form.js